<template>
  <v-container fluid class="pt-0 px-0">
    <v-row>
      <v-img 
        :height="$vuetify.breakpoint.mdAndUp ? '100vh' : '105vh'"
        :src="$vuetify.breakpoint.mdAndUp ? '/descubre/portada.jpg' : '/descubre/portada-ver.jpg'"
        class="mt-0 pt-5"
      >
      </v-img> 
    </v-row>
    <v-row>
      <v-col>
        <v-row justify="center" class="mx-12 mt-12">
            <p style="font-size: 1.3rem;text-align: justify">Nuestro modelo educativo se adapta a tus necesidades personales, laborales y profesionales, impulsando a que te superes sin dejar de lado tu trabajo, familia y economía, con programas que podrás cursar desde cualquier parte y en cualquier momento incorporado a inicios y calendarios definidos.</p>
            <br>
            <p style="font-size: 1.3rem;text-align: justify">Si deseas iniciar con tus estudios universitarios para obtener tu título y desenvolverte en las áreas gerenciales de tu trabajo, te resultará práctico y asequible recurrir a la educación superior en línea, ya que se adapta a tu estilo y forma de vida.</p>
        </v-row>
      </v-col>
      <v-col cols="12">
        <ContactFloat
          data-aos="fade-in"
          id="contact"
          :isMovil="$vuetify.breakpoint.mdAndUp ? false : true"
          :class="$vuetify.breakpoint.mdAndDown ? '' : 'mt-10'"
        />
      </v-col>
    </v-row>    
  </v-container>
</template>
<style scoped>

.color-buen-fin {
  background: black;
  padding-top: 6rem;
  padding-bottom: 6rem;
  border-bottom-left-radius: 4rem;
  border-bottom-right-radius: 4rem;
  margin-bottom: 6rem;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
</style>
<script>
import { mapState } from "vuex";
import ContactFloat from "../components/ContactFloat.vue";
export default {
  components: {
    ContactFloat,
  },
  mounted() {
    this.$store.dispatch("home/setModalImagen", false);
  },
  data: () => ({
  }),
};
</script>
